import { Link } from 'gatsby';
import React from 'react';

const Footer: React.FC = () => {
    const year = new Date().getFullYear();

    return (
        <footer className="w-full border-t border-grey">
            <div className="container flex py-8 lg:py-16 justify-between">
                <p className="font-base">&copy; {year} Prepared</p>
                <nav aria-label="Footer Links">
                    <ul className="font-base">
                        <li>
                            <Link
                                className="relative inline-block underline-link focus-visible:outline focus-visible:outline-2 focus-visible:outline-white"
                                to="/impressum/"
                            >
                                Impressum
                            </Link>
                        </li>
                    </ul>
                </nav>
            </div>
            <div aria-hidden="true" className="enable-animation">
                <div className="relative flex overflow-hidden select-none gap-4">
                    {Array.from({ length: 2 }).map((_, idx) => (
                        <p
                            key={idx}
                            className="marquee__content whitespace-nowrap marquee-text pr-4"
                        >
                            Building better Ecom
                        </p>
                    ))}
                </div>
            </div>
        </footer>
    );
};

export default Footer;
